var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFingerprint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8a8 8 0 0 1 14 3v3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13v-1a8.5 8.5 0 0 1 .3-2.2M20 17l-.4 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19c1-2 1-4 1-7a4 4 0 0 1 8 0v3c0 2 .3 3.7 1 5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16c.4-1 .5-2.5 .5-4a6.5 6.5 0 0 1 13 0v3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21c1.2-2.5 1.5-5.5 1.5-9a.5.5 0 0 1 1 0c0 3.7 .3 6.8 1.3 9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprint);
export default __webpack_public_path__ + "static/media/fingerprint.55d58ed354ea9b22b1e439b5ca6b04a9.svg";
export { ForwardRef as ReactComponent };